// @flow

export const THEME_STORAGE_KEY: string = "overclick-theme";
